import { ref, onBeforeUnmount } from 'vue'

interface PositionState {
  top: number
  left: number
  width: number
  height: number
  windowWidth: number
  windowHeight: number
}

export function usePositionTracking(
  getElement: () => Element | null | undefined,
  onPositionChange: () => void
) {
  const rafId = ref<number | null>(null)
  const lastState = ref<PositionState>({
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    windowWidth: 0,
    windowHeight: 0,
  })

  function track() {
    const element = getElement()
    if (element) {
      const rect = element.getBoundingClientRect()
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight

      if (
        rect.top !== lastState.value.top ||
        rect.left !== lastState.value.left ||
        rect.width !== lastState.value.width ||
        rect.height !== lastState.value.height ||
        windowWidth !== lastState.value.windowWidth ||
        windowHeight !== lastState.value.windowHeight
      ) {
        lastState.value = {
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: rect.height,
          windowWidth,
          windowHeight,
        }
        onPositionChange()
      }
    }

    rafId.value = requestAnimationFrame(track)
  }

  function startTracking() {
    rafId.value = requestAnimationFrame(track)
  }

  function stopTracking() {
    if (rafId.value !== null) {
      cancelAnimationFrame(rafId.value)
      rafId.value = null
    }
  }

  onBeforeUnmount(() => {
    stopTracking()
  })

  return {
    startTracking,
    stopTracking,
  }
}
